import { createContext } from "react";

const EmployeeContractTypeContext = createContext();

export default EmployeeContractTypeContext